"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimplifyQuotePlanResults = exports.SimplifiedQuotePropTypes = exports.SimplifiedQuoteContextPropTypes = exports.LoadingCodes = exports.GetSimplifiedQuoteContext = exports.GetQuoteForPlanVariation = exports.GetDiscountFromLoadings = exports.GetAllAppliedDiscountsFromLoadings = exports.FilterQuotesByVariations = exports.FREQUENCY_OPTIONS = exports.FREQUENCIES = exports.ExtractLoadings = exports.ExtractAllLoadings = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _planHelpers = require("./planHelpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /* eslint-disable max-len, react/prop-types */
var LoadingCodes = exports.LoadingCodes = {
  DISCOUNT: 'DISCOUNT',
  PROMOTION: 'PROMOTION',
  FREEMONTH: '1MONTHFREE'
};
var ExtractAllLoadings = exports.ExtractAllLoadings = function ExtractAllLoadings(_ref) {
  var productQuotes = _ref.productQuotes;
  return Object.values(productQuotes).map(function (quote) {
    var _quote$variations;
    return (_quote$variations = quote === null || quote === void 0 ? void 0 : quote.variations) !== null && _quote$variations !== void 0 ? _quote$variations : [];
  }).reduce(function (acc, variations) {
    return acc.concat(variations);
  }, []).map(function (variation) {
    var _variation$payment$lo, _variation$payment;
    return (_variation$payment$lo = variation === null || variation === void 0 || (_variation$payment = variation.payment) === null || _variation$payment === void 0 ? void 0 : _variation$payment.loadings) !== null && _variation$payment$lo !== void 0 ? _variation$payment$lo : [];
  }).reduce(function (acc, loadings) {
    return acc.concat(loadings);
  }, []);
};
var ExtractLoadings = exports.ExtractLoadings = function ExtractLoadings(_ref2) {
  var productQuote = _ref2.productQuote;
  return productQuote === null || productQuote === void 0 ? void 0 : productQuote.variations.map(function (variation) {
    var _variation$payment$lo2, _variation$payment2;
    return (_variation$payment$lo2 = variation === null || variation === void 0 || (_variation$payment2 = variation.payment) === null || _variation$payment2 === void 0 ? void 0 : _variation$payment2.loadings) !== null && _variation$payment$lo2 !== void 0 ? _variation$payment$lo2 : [];
  }).reduce(function (acc, loadings) {
    return acc.concat(loadings);
  }, []);
};
var GetDiscountFromLoadings = exports.GetDiscountFromLoadings = function GetDiscountFromLoadings(_ref3) {
  var loadings = _ref3.loadings;
  var discounts = loadings.filter(function (_ref4) {
    var loadingBase = _ref4.loadingBase;
    return loadingBase < 0;
  });
  if (!discounts || discounts.length === 0) {
    return null;
  }
  var biggestDiscount = discounts.reduce(function (prev, current) {
    return prev.y > current.y ? prev : current;
  });
  return biggestDiscount && biggestDiscount.loadingCode ? biggestDiscount.loadingCode : 0;
};
var GetAllAppliedDiscountsFromLoadings = exports.GetAllAppliedDiscountsFromLoadings = function GetAllAppliedDiscountsFromLoadings(_ref5) {
  var allLoadings = _ref5.allLoadings;
  var multiplePetDiscount = allLoadings.find(function (loading) {
    return loading.loadingCode === LoadingCodes.DISCOUNT && loading.loadingName.toLowerCase().indexOf('multipet') >= 0;
  });
  var memberDiscount = allLoadings.find(function (loading) {
    return loading.loadingCode === LoadingCodes.DISCOUNT && loading.loadingName.toLowerCase().indexOf('member') >= 0 && loading.loadingBase < 0 && loading.webDisplayValue === true;
  });
  var promoDiscount = allLoadings.find(function (loading) {
    return LoadingCodes.PROMOTION === loading.loadingCode && loading.loadingBase < 0 && loading.webDisplayValue === true;
  });
  var freeMonthDiscount = allLoadings.find(function (loading) {
    return loading.loadingCode === LoadingCodes.FREEMONTH && loading.premiumFreeValue !== 0;
  });
  return {
    freeMonthDiscount: freeMonthDiscount,
    memberDiscount: memberDiscount,
    promoDiscount: promoDiscount,
    multiplePetDiscount: multiplePetDiscount
  };
};
var FREQUENCIES = exports.FREQUENCIES = {
  'FORTNIGHTL': {
    tableHeadDisplayText: 'per fortnight',
    frequencyDisplayText: 'Fortnightly',
    collectionFee: true
  },
  'MONTHLY': {
    tableHeadDisplayText: 'per month',
    frequencyDisplayText: 'Monthly',
    collectionFee: true
  },
  'ANNUALLY': {
    tableHeadDisplayText: 'per year',
    frequencyDisplayText: 'Yearly'
  }
};
var FREQUENCY_OPTIONS = exports.FREQUENCY_OPTIONS = Object.keys(FREQUENCIES);
var SimplifiedQuotePropTypes = exports.SimplifiedQuotePropTypes = {
  planNumber: _propTypes["default"].string,
  planQuote: _propTypes["default"].shape({
    excess: _propTypes["default"].shape({
      value: _propTypes["default"].number,
      code: _propTypes["default"].string
    }),
    levelOfCover: _propTypes["default"].shape({
      value: _propTypes["default"].number,
      format: _propTypes["default"].string,
      code: _propTypes["default"].string
    }),
    payment: _propTypes["default"].shape({
      total: _propTypes["default"].number,
      base: _propTypes["default"].number,
      discountType: _propTypes["default"].string,
      collectionFee: _propTypes["default"].number
    }),
    annualBenefitLimit: _propTypes["default"].number
  }),
  onPlanSelect: _propTypes["default"].func
};
var SimplifyQuotePlanResults = exports.SimplifyQuotePlanResults = function SimplifyQuotePlanResults(_ref6) {
  var productQuotes = _ref6.productQuotes;
  /* Quote results consist of an array with each plan broken up by variations:
      - level of cover
      - excess
      - paymentFrequency
    The model we are creating will conform to SimplifiedQuotePropTypes.planQuote above.
   */

  return productQuotes.reduce(function (acc, quoteResult) {
    var annualBenefitLimit = quoteResult.annualBenefitLimit,
      excess = quoteResult.excess,
      excessCode = quoteResult.excessCode,
      levelOfCover = quoteResult.levelOfCover,
      levelOfCoverCode = quoteResult.levelOfCoverCode,
      paymentFrequencyCode = quoteResult.paymentFrequencyCode,
      planNumber = quoteResult.planNumber,
      totalCollectionFee = quoteResult.totalCollectionFee,
      totalPremiumAmount = quoteResult.totalPremiumAmount,
      totalPremiumAmountWithoutDiscount = quoteResult.totalPremiumAmountWithoutDiscount,
      loadings = quoteResult.loadings;
    var variation = {
      planNumber: planNumber,
      excess: {
        value: excess,
        code: excessCode
      },
      levelOfCover: {
        value: levelOfCover,
        format: 'percent',
        code: levelOfCoverCode
      },
      payment: {
        frequency: paymentFrequencyCode,
        total: totalPremiumAmount,
        base: totalPremiumAmountWithoutDiscount,
        loadings: loadings,
        discount: GetDiscountFromLoadings({
          loadings: loadings
        }),
        collectionFee: totalCollectionFee
      },
      annualBenefitLimit: annualBenefitLimit
    };
    if (!acc[planNumber]) {
      acc[planNumber] = {
        paymentFrequencyOptions: [paymentFrequencyCode],
        variations: [variation]
      };
    } else {
      if (acc[planNumber].paymentFrequencyOptions.indexOf(paymentFrequencyCode) === -1) {
        acc[planNumber].paymentFrequencyOptions.push(paymentFrequencyCode);
      }
      acc[planNumber].variations.push(variation);
    }
    return acc;
  }, {});
};
var SimplifiedQuoteContextPropTypes = exports.SimplifiedQuoteContextPropTypes = {
  paymentFrequencyCode: _propTypes["default"].oneOf(FREQUENCY_OPTIONS),
  hasPromotionCode: _propTypes["default"].bool,
  promotionCode: _propTypes["default"].string,
  promotionMessage: _propTypes["default"].string,
  collectionFee: _propTypes["default"].number
};
var GetSimplifiedQuoteContext = exports.GetSimplifiedQuoteContext = function GetSimplifiedQuoteContext(_ref7) {
  var productQuotes = _ref7.productQuotes;
  var paymentFrequencyCode = productQuotes.paymentFrequencyCode,
    hasPromotionCode = productQuotes.hasPromotionCode,
    promotionCode = productQuotes.promotionCode,
    promotionMessage = productQuotes.promotionMessage;
  return {
    paymentFrequencyCode: paymentFrequencyCode,
    hasPromotionCode: hasPromotionCode,
    promotionCode: promotionCode,
    promotionMessage: promotionMessage
  };
};
var GetQuoteForPlanVariation = exports.GetQuoteForPlanVariation = function GetQuoteForPlanVariation(_ref8) {
  var productQuotes = _ref8.productQuotes,
    selectedPlanNumber = _ref8.selectedPlanNumber,
    selectedOptions = _ref8.selectedOptions,
    productsAreMerged = _ref8.productsAreMerged,
    planProductGroup = _ref8.planProductGroup;
  if (!productQuotes[selectedPlanNumber]) {
    return false;
  }
  return productQuotes[selectedPlanNumber].variations.find(function (variation) {
    return filterPredicate(variation, selectedOptions, planProductGroup, selectedPlanNumber, productsAreMerged);
  });
};
var filterPredicate = function filterPredicate(variation, selectedOptions, planProductGroup, selectedPlanNumber, productsAreMerged) {
  var plan = productsAreMerged ? selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.merged[planProductGroup] : selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.allPlans[selectedPlanNumber];
  return compareWithCurrentVariation(plan, variation);
};
var compareWithCurrentVariation = function compareWithCurrentVariation(plan, variation) {
  return (plan === null || plan === void 0 ? void 0 : plan.excess.toString()) === variation.excess.value.toString() && (plan === null || plan === void 0 ? void 0 : plan.levelOfCover.toString()) === variation.levelOfCover.value.toString();
};
var FilterQuotesByVariations = exports.FilterQuotesByVariations = function FilterQuotesByVariations(_ref9) {
  var productQuotes = _ref9.productQuotes,
    selectedOptions = _ref9.selectedOptions,
    productGroups = _ref9.productGroups,
    AllPlans = _ref9.AllPlans,
    AddOnsMap = _ref9.AddOnsMap,
    productsAreMerged = _ref9.productsAreMerged;
  return Object.entries(productQuotes).reduce(function (acc, _ref10) {
    var _ref11 = _slicedToArray(_ref10, 2),
      planNumber = _ref11[0],
      quoteResult = _ref11[1];
    var _FindMatchingPlanBase = (0, _planHelpers.FindMatchingPlanBasedOnVariants)({
        productDefinition: AllPlans["Plan_".concat(planNumber)],
        productGroup: productGroups["Plan_".concat(planNumber)],
        selectedOptions: selectedOptions,
        AllPlans: AllPlans,
        AddOnsMap: AddOnsMap
      }),
      selectedProduct = _FindMatchingPlanBase.selectedProduct;
    var quoteForPlanVariation = GetQuoteForPlanVariation({
      productQuotes: productQuotes,
      selectedPlanNumber: selectedProduct.planNumber || planNumber,
      selectedOptions: selectedOptions,
      productsAreMerged: productsAreMerged,
      planProductGroup: productGroups["Plan_".concat(planNumber)]
    });
    acc[planNumber] = quoteForPlanVariation;
    return acc;
  }, {});
};